// extracted by mini-css-extract-plugin
module.exports = {"container":"Auth_container__om7_V","title":"Auth_title__RzCKS","extraModalContentStyle":"Auth_extraModalContentStyle__D3epN"};